import React from 'react'
import redial from 'redial'
import DropDetailsPageAsync from './DropDetailsPage'
import DropsOverviewPageAsync from './DropsOverviewPage'
import { redialDropDetails, redialDropOverview } from './redial'

export const DropsOverviewPage = redial.provideHooks(redialDropOverview)(() => (
  <DropsOverviewPageAsync />
))
export const DropDetailsPage = redial.provideHooks(redialDropDetails)(() => {
  return <DropDetailsPageAsync />
})
